module.exports = __webpack_public_path__ + "img/noData.5eac80d0.png";